/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendDiscountRateDto } from '../../models/backend-discount-rate-dto';

export interface ProjectTaxesDiscountRatesList$Params {
  create_date?: string;
  discount_rate_general_install?: number;

  /**
   * * `own_value` - Свое значение
   * * `central_bank_rate` - По ставке ЦБ
   */
  discount_rate_source?: 'central_bank_rate' | 'own_value';
  is_blocked?: boolean;
  project?: number;
  reinvesting_rate?: number;

  /**
   * * `own_value` - Свое значение
   * * `central_bank_rate` - По ставке ЦБ
   */
  reinvesting_rate_source?: 'central_bank_rate' | 'own_value';
  variant_name?: string;
}

export function projectTaxesDiscountRatesList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectTaxesDiscountRatesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendDiscountRateDto>>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesDiscountRatesList.PATH, 'get');
  if (params) {
    rb.query('create_date', params.create_date, {});
    rb.query('discount_rate_general_install', params.discount_rate_general_install, {});
    rb.query('discount_rate_source', params.discount_rate_source, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('project', params.project, {});
    rb.query('reinvesting_rate', params.reinvesting_rate, {});
    rb.query('reinvesting_rate_source', params.reinvesting_rate_source, {});
    rb.query('variant_name', params.variant_name, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendDiscountRateDto>>;
    }),
  );
}

projectTaxesDiscountRatesList.PATH = '/api/project_taxes/discount_rates/';
